<template>
  <div class="recover-password">
    <v-parallax
      src="@/assets/header-parallax-4.jpg"
      height="200"
      class="page-header"
    >
      <v-container
        ><h1>
          {{ $t("texts.recoverPassword") }}
        </h1></v-container
      >
    </v-parallax>

    <v-form @submit.prevent="recoverPassword">
      <v-card color="grey lighten-5" elevation="4" class="page-content mx-auto">
        <h4 class="py-2 px-4 text-center">
          {{ $t("texts.recoverPasswordText") }}
        </h4>
        <v-row justify="center">
          <v-col cols="10">
            <a-text-field
              v-model="$v.email.$model"
              :validator="$v.email"
              :label="$t('texts.youremail')"
              type="email"
            />
          </v-col>
        </v-row>

        <div class="d-flex justify-center">
          <div class="mt-4 mb-4">
            <v-btn color="primary" block type="submit">{{
              $t("texts.recoverPasswordSimple")
            }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-form>
  </div>
</template>

<style scoped lang="sass">
@media (min-width: 599px)
  .v-card
    max-width: 55%
</style>

<script>
// @ is an alias to /src
import AppError from "@/utils/AppError.js";
import ATextField from "@/components/fields/ATextField.vue";

import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "recover-password",

  components: {
    ATextField
  },

  mixins: [validationMixin],

  validations: {
    email: { required, email }
  },

  data() {
    return {
      // Form data
      email: null
    };
  },

  methods: {
    /**
     * Recovers the password.
     * @public
     */
    recoverPassword() {
      // Check if form fields are valid
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.dispatch("Util/startLoading");
      this.$api({
        url: this.$config.api.route.authRecoverPassword,
        data: {
          email: this.email
        },
        method: "POST"
      })
        .then(() => {
          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.recoverpasswordsuccess")
          );

          // Reset fields and validations
          this.email = null;
          this.$v.$reset();
        })
        .catch(err => {
          AppError.handle(err);
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    }
  }
};
</script>
